<template>
  <div class="absolute fill-height events-page">
    <div class="absolute fill-height pb-3 gui-flex gui-flex-rows">
      <v-card flat class="no__radius mr-3 ml-3 table-wrap__padding wrap-scrollbar gui-flex-fill-rest gui-flex gui-flex-rows elevation-1">
        <Loader v-if="loading" skin="light"></Loader>
        <div v-else class="gui-flex gui-flex-rows">
          <div class="custom-scrollbar">
            <div>
              <v-layout row wrap>
                <v-flex xs12>
                  <h3>Obchody a&nbsp;provize</h3>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs12 sm4 md2>
                  <osobasearch label="Spolupracovník" v-model="spolupracovnik" :spolupracovnik="true" class="mx-2"></osobasearch>
                </v-flex>
                <v-flex xs12 sm4 md2>
                  <v-select
                    :items="obdobiItems"
                    class="mx-2"
                    label="Období"
                    v-model="obdobi"
                    return-object
                    item-text="text"
                  ></v-select>
                </v-flex>
                <v-flex xs12 sm4 md3>
                  <v-menu offset-y right v-model="menu" :close-on-content-click="false" class="mx-2 d-flex grow">
                    <v-text-field
                      label="Datum"
                      v-model="datum"
                      slot="activator"
                      readonly
                      class="mx-0"
                      :class="{'mx-2': $vuetify.breakpoint.smAndUp}" clearable
                    ></v-text-field>
                    <v-card>
                      <v-card-text>
                        <DateRangePicker
                          :options="dateRangeOptions"
                          @input="onDateRangeChange"
                          :labels="labels"
                          @close="menu=false"
                        />
                      </v-card-text>
                    </v-card>
                  </v-menu>
                </v-flex>
              </v-layout>
            </div>
            <div class="table-border__radius mt-3 elevation-1">
              <v-data-table
                :headers="headers"
                :items="items"
                :pagination.sync="pagination"
                :total-items="pagination.totalItems"
                :rows-per-page-items="[25, 50, 100, 200]"
                item-key="i"
                :loading="loadingTable"
              >
                <template slot="items" slot-scope="props">
                  <td>{{ props.item.id }}</td>
                  <td>{{ props.item.datum | formatDate }}</td>
                  <td>{{ props.item.spolupracovnik.nazev_osoby }}</td>
                  <td>{{ props.item.klient.nazev_osoby }}</td>
                  <td>
                    <span v-if="props.item.typ_obchodu=='sporeni'">Postupný nákup</span>
                    <span v-else-if="props.item.typ_obchodu=='jednorazovy_nakup'">Jednorázový nákup</span>
                  </td>
                  <td class="text-xs-right">{{ props.item.castka }} {{props.item.mena.zkratka}}</td>
                  <td class="text-xs-right">{{ props.item.kredity | formatDouble }}</td>
                  <td class="text-xs-right">{{ props.item.pozice_hodnota_kreditu }} Kč</td>
                  <td class="text-xs-right">{{ props.item.provize | formatMoney }} Kč</td>
                  <!--<td>{{ props.item.stav }}</td>-->
                  <td class="text-center">
                    <router-link :to="{ path: '/admin/obchody-a-provize/' + props.item.id }">
                      <v-btn color="primary" class="elevation-0">
                      <v-icon small class="mr-2">remove_red_eye</v-icon> Detail</v-btn>
                    </router-link>
                  </td>
                </template>
              </v-data-table>
            </div>
          </div>
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
import Base from '@/pages/Base'
import DateRangePicker from '@/components/DateRange';
export default {
  extends: Base,
  data () {
    return {
      loading: false,
      loadingTable: false,
      headers: [
        { text: 'ID', value: 'id' },
        { text: 'Datum', value: 'datum' },
        { text: 'Spolupracovník', value: 'spolupracovnik' },
        { text: 'Klient', value: 'klient' },
        { text: 'Typ obchodu', value: 'typ_obchodu' },
        { text: 'Částka', value: 'castka', align: 'right' },
        { text: 'Kredity', value: 'kredity', align: 'right' },
        { text: 'Hodnota kreditu', value: 'pozice_hodnota_kreditu', align: 'right' },
        { text: 'Provize', value: 'provize', align: 'right' },
        //{ text: 'Stav', value: 'stav' },
        { text: 'Zobrazit', value: null, sortable: false, align: 'center' }
      ],
      items: [],
      stav: [
        'Otevřeno',
        'Navrženo k vyúčtování',
        'Odsouhlaseno',
        'Fakturováno'
      ],
      obdobiItems: [],
      spolupracovnik: null,
      datum_od: null,
      datum_do: null,
      counter: 0,
      pagination: {
        descending: true,
        page: 1,
        rowsPerPage: 50,
        sortBy: "id",
        totalItems: 0
      },
      obdobi: null,
      dateRangeOptions: {
        startDate: moment().subtract("days", 7).format('YYYY-MM-DD'),
        endDate: moment().format('YYYY-MM-DD'),
        format: 'DD.MM.YYYY',
        presets: [
          {
            label: 'Dnes',
            range: [
              moment().format('YYYY-MM-DD'),
              moment().format('YYYY-MM-DD'),
            ],
          },
          {
            label: 'Včera',
            range: [
              moment().subtract("days", 1).format('YYYY-MM-DD'),
              moment().subtract("days", 1).format('YYYY-MM-DD'),
            ],
          },
          {
            label: 'Tento týden',
            range: [
              moment().startOf("week").format('YYYY-MM-DD'),
              moment().endOf("week").format('YYYY-MM-DD'),
            ],
          },
          {
            label: 'Minulý týden',
            range: [
              moment().subtract("weeks", 1).startOf("week").format('YYYY-MM-DD'),
              moment().subtract("weeks", 1).endOf("week").format('YYYY-MM-DD'),
            ],
          },
          {
            label: 'Tento měsíc',
            range: [
              moment().startOf("month").format('YYYY-MM-DD'),
              moment().endOf("month").format('YYYY-MM-DD'),
            ],
          },
          {
            label: 'Minulý měsíc',
            range: [
              moment().subtract("months", 1).startOf("month").format('YYYY-MM-DD'),
              moment().subtract("months", 1).endOf("month").format('YYYY-MM-DD'),
            ],
          }
        ],
      },
      range: [],
      labels: {
        start: "Začátek",
        end: "Konec"
      },
      menu: false,
      datum: null
    }
  },
  watch: {
    spolupracovnik () {
      this.load();
    },
    obdobi () {
      this.load();
    },
    pagination: {
      handler () {
        this.load();
      },
      deep: true
    },
    datum_od () {
      this.datum = moment(this.datum_od*1000).format("DD.MM.YYYY") + " - " + moment(this.datum_do*1000).format("DD.MM.YYYY");
    },
    datum_do () {
      this.datum = moment(this.datum_od*1000).format("DD.MM.YYYY") + " - " + moment(this.datum_do*1000).format("DD.MM.YYYY");
    }
  },
  mounted: function() {
    window.MenuListener.show();
    this.load();
    var start = moment("2019-01-01");
    while (!start.isSame(moment(), "month")) {
      var month = start.format("MMMM YYYY");
      month = month.charAt(0).toUpperCase() + month.slice(1);
      this.obdobiItems.unshift({
        text: month,
        od: parseInt(start.startOf("month").utc()._d.getTime() / 1000),
        do: parseInt(start.endOf("month").utc()._d.getTime() / 1000)
      });
      start.add("month", 1);
    }
    var month = moment().format("MMMM YYYY");
    month = month.charAt(0).toUpperCase() + month.slice(1);
    this.obdobiItems.unshift({
      text: month,
      od: parseInt(moment().startOf("month").utc()._d.getTime() / 1000),
      do: parseInt(moment().endOf("month").utc()._d.getTime() / 1000)
    });
    this.obdobiItems.unshift({
      text: "Vše",
      od: null,
      do: null
    });
    this.obdobi = this.obdobiItems[0];
  },
  methods: {
    queryList: function() {
      if (this.timeout != null)
        clearTimeout(this.timeout);
      this.timeout = setTimeout(function() {
        this.pagination.page = 1;
        this.load();
      }.bind(this), 200)
    },
    load: function() {
      this.counter++;
      this.loadingTable = true;
      window.API.post("prehledy/obchody-provize/search", {
        pagination: this.pagination,
        s: this.search,
        echo: this.counter,
        spolupracovnik: this.spolupracovnik,
        datum_od: this.obdobi != null ? this.obdobi.od : null,
        datum_do: this.obdobi != null ? this.obdobi.do : null,
        datum_od_2: this.datum_od,
        datum_do_2: this.datum_do
      }).then(function(body) {
        if (this.counter != body.echo)
          return;
        var c = 0;
        this.items.replace(body.data.map((e) => { e.i = c++; return e; }));
        this.pagination.sortBy = body.sort.sortBy;
        this.pagination.descending = body.sort.descending;
        this.pagination.page = body.sort.page;
        this.pagination.rowsPerPage = body.sort.rowsPerPage;
        this.pagination.totalItems = body.sort.totalItems;
        this.loading = false;
        this.loadingTable = false;
      }.bind(this)).catch(function(err) {
        console.log(err);
      }.bind(this));
    },
    onDateRangeChange (e) {
      this.datum_od = parseInt(moment(e[0]).startOf("day")._d.getTime()/1000);
      this.datum_do = parseInt(moment(e[1]).endOf("day")._d.getTime()/1000);
      this.load();
    }
  },
  components: {
    DateRangePicker
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Admin/ObchodyProvize.vue